const hasCreatorAvatar = (creator, currentLibrary) => {
  const homeLibrarySubdomain = creator.get('homeLibrarySubdomain');
  const isStaff = creator.get('staff') ?? false;
  const librarySubdomain = currentLibrary.get('domain');

  return isStaff && homeLibrarySubdomain === librarySubdomain;
};

const hasLibraryName = creator => {
  const isStaff = creator.get('staff') ?? false;
  const libraryName = creator.get('homeLibraryFullName');

  return isStaff && Boolean(libraryName);
};

export { hasCreatorAvatar, hasLibraryName };
